import React, { FC, useState, useMemo, useEffect } from 'react';
import {
  ModalContainer,
  StyledAdditionally,
  StyledBtnIcon,
  StyledButton,
  StyledButtonIconBlock,
  StyledButtons,
  StyledCompare,
  StyledDivBtnAdditionally,
  StyledDivBtnIcon,
  StyledFavorite,
  StyledInfo,
  StyledLink,
  StyledList,
  StyledListItem,
  StyledPriceBlock,
  StyledProductLink,
  StyledTrustedSellerBlock,
} from './styles';
import { CloseIcon, WhatsAppIcon } from '../../../icons';
import callbackIcon from '../../../assets/images/svg/callbackIcon.svg';
import Modal from '@mui/material/Modal';
import { Box, Button, Typography } from '@mui/material';
import { modalStyle } from './styles';
import SellTradeForm from '../../SellTrade/form/SellTradeForm';
import { OfferTypeEnum } from '../../SellTrade/types/SellTradeForm.types';
import { useAppSelector, useAppStore } from '../../../hooks/reduxHooks';
import { formatter } from '../../../utils/helpers/formatters';
import Callback from '../Callback/Callback';

import { FavoriteIcon } from '../../../icons';
import { FavoriteFilledIcon } from '../../../icons/FavoriteFilledIcon';
import {
  addOrRemoveCompareProducts,
  addOrRemoveFavoriteProducts,
  isFavorite,
  isInCompare,
} from '../../../utils/localStorageUtils';
import Image from 'next/image';
import ContentLoader from 'react-content-loader';
import { IProduct } from '../../../interfaces/product';
import TrustedSeller from '../../../../public/img/trusted-seller-icon.svg';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import CompareArrowsOutlinedIcon from '@mui/icons-material/CompareArrowsOutlined';
import { useRouter } from 'next/navigation';

interface PriceBlockProps {
  ssrProduct?: IProduct;
}

const PriceBlock: FC<PriceBlockProps> = ({ ssrProduct }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [compareOpen, setCompareOpen] = useState<boolean>(false);
  const [modal, setModal] = useState<string>('');
  const stateProduct = useAppSelector((st) => st.products.product);
  const locale = useAppSelector((st) => st.locale);
  const { selectedCurrency } = useAppSelector((st) => st.currency);
  const store = useAppStore();
  const router = useRouter();

  const [product, setProduct] = useState<IProduct | undefined>(ssrProduct);

  useEffect(() => {
    if (stateProduct) setProduct(stateProduct);
  }, [stateProduct]);

  const messages = useMemo(() => {
    return {
      all_watches: locale['heromock_all_watches_title'],
      button_buy_or_trade: locale['product_button_buy_or_trade'],
      button_whatsapp: locale['product_button_whatsapp'],
      button_call_back: locale['product_button_call_back'],
      info_0: locale['product_price_block_info_0'],
      info_1_0: locale['product_price_block_info_1_0'],
      info_1_1: locale['product_price_block_info_1_1'],
      info_2: locale['product_price_block_info_2'],
      info_3: locale['product_price_block_info_3'],
      securePayment: locale['product_secure_payment'],

      compare_added_title: locale['compare_added_to_compare'],
      compare_added_goToCompare: locale['compare_go_to_compare'],
      compare_added_continue: locale['compare_continue'],
      compare_added_or: locale['compare_or'],
    };
  }, [locale]);

  function openModal(option: string) {
    setModal(option);
    setOpen(true);
  }

  function goToWhatsapp() {
    const url = 'https://wa.me/420739221010';
    window.open(url, '_blank');
  }

  function compareClicked() {
    if (isInCompare(product, store)) {
      router.push('/compare');
    } else {
      addOrRemoveCompareProducts(product, store);
      setCompareOpen(true);
    }
  }

  return (
    <StyledPriceBlock>
      {product?.model ? (
        <StyledInfo>
          <div style={{ position: 'relative' }}>
            <Typography
              variant={'h2'}
              component={'p'}
              sx={{
                cursor: 'pointer',
                fontSize: { xs: '36px', md: '48px' },
                lineHeight: { xs: '32px', md: '52px' },
                marginBottom: { xs: '1px' },
              }}
            >
              {product?.model?.brand?.name || ''}
            </Typography>
            <StyledFavorite onClick={() => addOrRemoveFavoriteProducts(product, store)}>
              {isFavorite(product, store) ? <FavoriteFilledIcon size={19} /> : <FavoriteIcon size={19} />}
            </StyledFavorite>

            <StyledCompare onClick={() => compareClicked()} title='Compare'>
              {isInCompare(product, store) ? <CompareArrowsIcon /> : <CompareArrowsOutlinedIcon />}
            </StyledCompare>
          </div>
          <Typography
            variant={'h4'}
            component={'p'}
            sx={{ fontSize: { xs: '28px', md: '28px' }, lineHeight: { xs: '34px' } }}
          >
            {product?.model?.name || ''}
          </Typography>
          {product?.price ? (
            <Typography
              variant={'h1'}
              component={'p'}
              sx={{ fontSize: { md: '32px' }, lineHeight: { md: '40px' }, fontWeight: { md: 450 } }}
            >
              {formatter(product?.price || 0, selectedCurrency) || ''}
            </Typography>
          ) : null}
          {product?.price === 0 && (
            <Typography
              variant={'h1'}
              component={'p'}
              sx={{ fontSize: { md: '32px' }, lineHeight: { md: '40px' }, fontWeight: { md: 450 } }}
            >
              Price on request
            </Typography>
          )}
          <Typography
            variant={'body1'}
            component={'h1'}
            sx={{ lineHeight: { md: '24px' }, color: '#535353', marginTop: { xs: '14px', md: '16px', lg: '16px' } }}
          >
            {product?.name || ''}
          </Typography>
        </StyledInfo>
      ) : (
        <Box sx={{ display: 'flex', alignContent: 'center', justifyContent: 'start' }}>
          <ContentLoader
            speed={2}
            height={210}
            viewBox='0 0 100% 210'
            backgroundColor='#f3f3f3'
            foregroundColor='#ecebeb'
            uniqueKey='about-block-title-loader'
            style={{
              textAlign: 'left',
              width: '100%',
            }}
          >
            <rect x='0' y='0' rx='3' ry='3' width='75%' height='35' />
            <rect x='0' y='60' rx='3' ry='3' width='40%' height='26' />
            <rect x='0' y='100' rx='3' ry='3' width='35%' height='30' />
            <rect x='0' y='150' rx='3' ry='3' width='100%' height='15' />
            <rect x='0' y='175' rx='3' ry='3' width='60%' height='15' />
          </ContentLoader>
        </Box>
      )}

      <StyledButtonIconBlock>
        <StyledButtons>
          <StyledButton
            style={{ width: '382px', height: '48px', maxWidth: '100%' }}
            variant='contained'
            aria-label='Buy or Trade'
            onClick={() => openModal('buyOrTrade')}
          >
            {messages.button_buy_or_trade ?? 'Buy or Trade'}
          </StyledButton>
          <StyledButton
            style={{ width: '48px', minWidth: '48px', height: '48px' }}
            variant='outlined'
            aria-label='WhatsApp'
            onClick={goToWhatsapp}
          >
            <WhatsAppIcon size={18} />
          </StyledButton>
          <StyledButton
            style={{ width: '48px', minWidth: '48px', height: '48px' }}
            variant='outlined'
            aria-label='Request callback'
            onClick={() => openModal('callback')}
          >
            <Image src={callbackIcon} alt='Callback Icon' width='18' height='18' />
          </StyledButton>
        </StyledButtons>
      </StyledButtonIconBlock>

      {product?.url && product?.syncWithChrono ? (
        <StyledProductLink>
          <span>
            {messages.securePayment}{' '}
            <StyledLink href={product?.url} target='_blank' rel='noreferrer'>
              Chrono24 Trusted Checkout
            </StyledLink>
          </span>
        </StyledProductLink>
      ) : null}
      <StyledAdditionally>
        <StyledTrustedSellerBlock>
          <div>
            <StyledList>
              <StyledListItem>
                <Typography
                  variant={'body1'}
                  sx={{
                    fontSize: { md: '18px' },
                    lineHeight: { md: '24px' },
                    color: '#535353',
                    maxWidth: { xs: '278px' },
                  }}
                >
                  {messages.info_0}
                </Typography>
              </StyledListItem>
              <StyledListItem>
                <Typography
                  variant={'body1'}
                  sx={{ fontSize: { md: '18px' }, lineHeight: { md: '24px' }, color: '#535353' }}
                >
                  {messages.info_1_0} &#38; {messages.info_1_1}
                </Typography>
              </StyledListItem>
              <StyledListItem>
                <Typography
                  variant={'body1'}
                  sx={{ fontSize: { md: '18px' }, lineHeight: { md: '24px' }, color: '#535353' }}
                >
                  {messages.info_2}
                </Typography>
              </StyledListItem>
              <StyledListItem>
                <Typography
                  variant={'body1'}
                  sx={{ fontSize: { md: '18px' }, lineHeight: { md: '24px' }, color: '#535353' }}
                >
                  {messages.info_3}
                </Typography>
              </StyledListItem>
            </StyledList>
          </div>
          <StyledDivBtnIcon>
            <StyledBtnIcon src={TrustedSeller} alt='Trusted Seller Icon' height={140} width={96}></StyledBtnIcon>
          </StyledDivBtnIcon>
          <StyledDivBtnAdditionally>
            <Image width={58} height={82} src={TrustedSeller} alt='Trusted Seller Icon' />
          </StyledDivBtnAdditionally>
        </StyledTrustedSellerBlock>
      </StyledAdditionally>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={modalStyle}>
          <ModalContainer>
            <div className='content-wrapper'>
              {modal === 'callback' ? (
                <Callback manageModal={() => setOpen(false)} contactType='Callback' serviceTypeEnum={null} />
              ) : (
                <div style={{ padding: '0 24px' }}>
                  <SellTradeForm offerType={OfferTypeEnum.Trade} forModal manageModal={() => setOpen(false)} />
                </div>
              )}
            </div>
            <div className='close-icon' onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </ModalContainer>
        </Box>
      </Modal>

      <Modal
        open={compareOpen}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
        onClose={() => setCompareOpen(false)}
      >
        <Box sx={modalStyle}>
          <ModalContainer>
            <div className='content-wrapper'>
              <Box
                sx={{
                  paddingTop: '60px',
                  paddingBottom: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <Typography sx={{ fontSize: '24px', fontWeight: 450, marginBottom: '20px' }}>
                  {messages.compare_added_title}
                </Typography>
                <Button onClick={() => router.push('/compare')}>{messages.compare_added_goToCompare}</Button>
                <div style={{ padding: '10px 0' }}>{messages.compare_added_or}</div>
                <Button onClick={() => setCompareOpen(false)}>{messages.compare_added_continue}</Button>
              </Box>
            </div>
            <div className='close-icon' onClick={() => setCompareOpen(false)}>
              <CloseIcon />
            </div>
          </ModalContainer>
        </Box>
      </Modal>
    </StyledPriceBlock>
  );
};

export default PriceBlock;
